import React, { useState } from "react";
import { Button } from "@mui/material";

import SelectUserDialog from "../../../dialogs/SelectUserDialog";
import { InfegyUser } from "system/InfegyUser";
import { useTranslation } from "react-i18next";

interface SelectUserButtonProps {
  disabled?: boolean;
  onChange: (user: any) => void;
  user: InfegyUser | null | undefined;
}

export default function SelectUserButton(props: SelectUserButtonProps): React.JSX.Element {
  const [open, setOpen] = useState<boolean>(false);
  const {i18n, t} = useTranslation();

  function handleUserSelected(user: InfegyUser) {
    setOpen(false);
    props.onChange(user);
  }

  const defaultLabel = t("select-user-button.label");

  return (
    <>
      <Button 
        disabled={props.disabled}
        onClick={() => setOpen(true)}
        variant="outlined"
      >
        {props.user?.name || defaultLabel}
      </Button>
      {open &&
        <SelectUserDialog
          onChange={handleUserSelected}
          onClose={() => setOpen(false)}
          open={open}
        />
      }
    </>
  )
}